import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class PaymentStatusApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

// Estados de pagamento das faturas (tabela de referência gerível nas Definições).
export interface PaymentStatus {
  id: number;
  code: string;
  name: string;
  sortOrder: number;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    // O backend devolve ProblemDetails; o "detail" traz a mensagem legível (ex.: estado em uso).
    let message = text || response.statusText;
    try {
      const problem = JSON.parse(text);
      if (typeof problem?.detail === "string" && problem.detail) {
        message = problem.detail;
      } else if (typeof problem?.title === "string" && problem.title) {
        message = problem.title;
      }
    } catch {
      // corpo não-JSON → usa o texto tal como veio
    }
    throw new PaymentStatusApiError(response.status, message);
  }

  // 204 No Content (DELETE) → nada para desserializar.
  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
}

export function getPaymentStatuses(): Promise<PaymentStatus[]> {
  return request<PaymentStatus[]>("/api/financial-approval-statuses");
}

export function createPaymentStatus(name: string): Promise<PaymentStatus> {
  return request<PaymentStatus>("/api/financial-approval-statuses", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
}

export function updatePaymentStatus(
  id: number,
  input: { name: string; sortOrder?: number | null },
): Promise<PaymentStatus> {
  return request<PaymentStatus>(`/api/financial-approval-statuses/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function deletePaymentStatus(id: number): Promise<void> {
  return request<void>(`/api/financial-approval-statuses/${id}`, {
    method: "DELETE",
  });
}
